import React from 'react';

import { ThemeProvider } from './AppContext';
import { Toggle, Content, Buttons, Particles, Matrix } from './../components';
import './app.scss';

const App = () => {

  let chance = Math.random() > 0.2;

  return (
    <ThemeProvider>
      <div className='app'>
        <Content />
        <Buttons />
        <Matrix />
      </div>
    </ThemeProvider>
  );
};

export default App;
